<template>
  <div class="enter_innovation_wrap">
    <div class="enter_img">
      <div class="img_tit hidden-xs-only">中试检测</div>
      <div class="img_desc hidden-xs-only">
        打造氢能产业新基建，加速环境优化高质量发展
      </div>
      <div class="img_tit hidden-sm-and-up">
        打造氢能产业新基建<br />加速环境优化高质量发展
      </div>
    </div>
    <div class="current_show_menu">
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="enter_title">氢燃料电池开发测试中心及中试基地</div>
            <div class="enter_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img src="@/assets/jiance1.png" alt="" />
        </div>
        <div class="mall_details">
          <ul>
            <li>
              <span class="title">核心方向：</span>
              验证制氢、 加氢、 甲醇加注、 充电合建站、 运 营协同，
              规范综合能源站建设程序
            </li>
            <li>
              <span class="title">建设地点：</span>
              嘉兴秀洲
            </li>
            <li>
              <span class="title">总投资 ：</span>
              约6300万元
            </li>
            <li>
              <span class="title">建设进展：</span>
              推进中，已基本完成加氢站部分主体施工，预计
              2025年10月验收并投入使用。
            </li>
          </ul>
        </div>
      </div>
      <div class="func">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">
                电解水制氢装备开发测试中心及中试基地
              </div>
              <div class="enter_desc"></div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="mall_wrap">
          <div class="mall_details">
            <ul>
              <li>
                <span class="title">核心方向：</span>
                50-4000标方的电解制氢设备检测和中试平台
              </li>
              <li>
                <span class="title">建设地点：</span>
                嘉兴市、 金华市
              </li>
              <li>
                <span class="title">总投资 ：</span>
                约6500万元
              </li>
              <li>
                <span class="title">建设进展：</span>
                项目主体已竣工，待验收；设备安装中，预计 2025年9月底前投入运营。
              </li>
            </ul>
          </div>
          <div class="mall_img">
            <img src="@/assets/jiance2.png" alt="" />
          </div>
        </div>
      </div>
      <div class="enter_title_wrap">
        <div class="enter_inner">
          <div class="inner_left">
            <img src="../../assets/img/tupianright.png" alt="" />
          </div>
          <div class="inner_center">
            <div class="enter_title">掺氢天然气装备开发测试中心及中试基地</div>
            <div class="enter_desc"></div>
          </div>
          <div class="inner_right">
            <img src="../../assets/img/tupianleft.png" alt="" />
          </div>
        </div>
      </div>
      <div class="mall_wrap">
        <div class="mall_img">
          <img src="@/assets/jiance3.png" alt="" />
        </div>
        <div class="mall_details">
          <ul>
            <li>
              <span class="title">核心方向：</span>
              解决掺氢天然气关键技术及设备系统集成、 现场
              实际应用检测验证等技术问题
            </li>
            <li>
              <span class="title">建设地点：</span>
              内蒙古通辽市
            </li>
            <li>
              <span class="title">总投资 ：</span>
              约8000万元
            </li>
            <li>
              <span class="title">建设进展：</span>
              推进中。
            </li>
          </ul>
        </div>
      </div>
      <div class="func">
        <div class="enter_title_wrap">
          <div class="enter_inner">
            <div class="inner_left">
              <img src="../../assets/img/tupianright.png" alt="" />
            </div>
            <div class="inner_center">
              <div class="enter_title">未来能源服务站模式验证中心</div>
              <div class="enter_desc"></div>
            </div>
            <div class="inner_right">
              <img src="../../assets/img/tupianleft.png" alt="" />
            </div>
          </div>
        </div>
        <div class="mall_wrap">
          <div class="mall_details">
            <ul>
              <li>
                <span class="title">核心方向：</span>
                验证制氢、 加氢、 甲醇加注、 充电合建站、 运 营协同，
                规范综合能源站建设程序
              </li>
              <li>
                <span class="title">建设地点：</span>
                嘉兴秀洲
              </li>
              <li>
                <span class="title">总投资 ：</span>
                约6300万元
              </li>
              <li>
                <span class="title">建设进展：</span>
                推进中，已基本完成加氢站部分主体施工，预计
                2025年10月验收并投入使用。
              </li>
            </ul>
          </div>
          <div class="mall_img">
            <img src="@/assets/jiance4.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CallMe from "@/components/callme/index";
import MobileCallme from "@/components/callme/MobileCallme.vue";
export default {
  data() {
    return {
      selectName: "1",
      funcCardList: [
        {
          tit: "数字化创新服务平台",
          desc: [
            "试剂耗材、仪器设备及专业技术服务供应商信息检索及技术咨询",
            "服务需求线上交易",
            "政企互动",
            "AI/大数据线上精准匹配服务",
          ],
          bg: require("../../assets/img/bg1.png"),
        },
        {
          tit: "创新服务综合体",
          desc: [
            "入驻优质供应商，并对其提供产品和技术服务展示区、技术培训区、学术交流区等",
            "专业运营团队对区域企业在研发和生产过程中的需求进行线下对接",
          ],
          bg: require("../../assets/img/bg2.png"),
        },
        {
          tit: "仓储转运中心",
          desc: ["上游供应商前置仓库", "园区企业共享仓库"],
          bg: require("../../assets/img/bg3.png"),
        },
        {
          tit: "自贸区清关和仓储中心",
          desc: [
            "北京、上海、广州、成都自贸区提供进口物料和设备仓储及通关服务，服务全国BioMall",
          ],
          bg: require("../../assets/img/bg3.png"),
        },
      ],
    };
  },
  methods: {
    selectMenuItem(name) {
      console.log(name);
    },
    gotoDemo() {
      this.$router.push("/demo");
    },
  },
  components: {
    CallMe,
    MobileCallme,
  },
};
</script>

<style lang="scss" scoped>
.enter_innovation_wrap {
  width: 100%;
  .enter_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url("../../assets/img/banner22.png") 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
        text-align: center;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      text-align: center;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }
  .enter_menu_wrap {
    @media screen and (max-width: 768px) {
      height: 40px;
    }
    .enter_menu_item {
      width: 50%;
      text-align: center;
      font-size: 22px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .enter_title_wrap {
    width: 100%;
    margin-top: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
    }
    .enter_inner {
      display: flex;
      justify-content: center;
      .inner_left {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30% !important;
        }
      }
      .inner_center {
        width: 850px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 50px;
        @media screen and (max-width: 768px) {
          flex: 8;
        }
        .enter_title {
          font-size: 40px;
          font-weight: bold;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }
        .enter_desc {
          font-size: 16px;
          color: #787878;
          margin-top: 10px;
          @media screen and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }
      .inner_right {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        @media screen and (max-width: 768px) {
          flex: 1;
        }
        img {
          width: 30% !important;
        }
      }
    }
  }
  .current_show_menu {
    .enter_card_wrap_mobile {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .enter_card_wrap {
      width: 100%;
      margin-top: 50px;
      .enter_card_item {
        background: #f4f9fc;
        text-align: center;
        p {
          width: 60%;
          text-align: center;
          margin: 0 auto;
          font-size: 16px;
        }
        .title {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
    .func {
      background: url("../../assets/img/bg_0.png");
      background-size: 100% 100%;
      padding: 20px 0;
    }
    .mall_wrap {
      width: 70%;
      display: flex;
      justify-content: center;
      margin: 34px auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      @media screen and (max-width: 768px) {
        flex-direction: column;
      }
      .mall_img {
        width: 50%;
        margin-right: 30px;
        padding: 0 30px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
        img {
          width: 100%;
        }
      }
    }
    .mall_details {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      font-size: 26px;
      li {
        margin-bottom: 10px;
      }
      .title {
        color: #048c4c;
        font-weight: 700;
      }
      @media screen and (max-width: 768px) {
        width: 90%;
        margin-left: 20px;
        font-size: 14px;
      }
      p {
        font-size: 20px;
        @media screen and (max-width: 768px) {
          font-size: 14px;
        }
      }
      .mall_btn {
        margin-top: 40px;
        @media screen and (max-width: 768px) {
          padding: 20px 0;
        }
        .btn_self {
          background: orange;
          color: #fff;
          border-radius: 20px;
          border: none;
          @media screen and (max-width: 768px) {
            width: 80px;
            height: 35px;
            border-radius: 20px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .func_wrap {
    width: 100%;
    padding: 50px;
    background: url("../../assets/img/bg_0.png");
    background-size: 100% 100%;
    .func_wrap_inner {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      .func_tit {
        font-size: 34px;
        font-weight: bold;
        text-align: center;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
        }
      }
      .func_card {
        justify-content: space-between;
        margin-top: 40px;
        .card_item {
          background: #fff;
          box-shadow: 5px 5px 30px rgba(0, 0, 0, 0.1);
          .item_top {
            width: 100%;
            height: 150px;
            font-size: 24px;
            font-weight: bold;
            color: #fff;
            background-size: 100% 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .item_bottom {
            padding: 15px;
            p {
              font-size: 16px;
              margin-top: 20px;
            }
          }
        }
      }
      .func_card_mobile {
        width: 100%;
        img {
          width: 100%;
          margin-top: 40px;
        }
      }
    }
    .double_card_wrap {
      width: 70%;
      margin: 0 auto;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
      .double_card {
        justify-content: space-between;
        margin-top: 50px;
        @media screen and (max-width: 768px) {
          flex-wrap: wrap;
        }
        .double_card_item {
          height: 250px;
          background: rgba($color: #fff, $alpha: 1);
          padding: 30px;
          display: flex;
          justify-content: center;
          align-items: flex-start;
          flex-direction: column;
          &:nth-child(1) {
            background-image: url("../../assets/img/bg_1.png");
          }
          &:nth-child(2) {
            background-image: url("../../assets/img/bg_2.png");
          }
          &:nth-child(3) {
            background-image: url("../../assets/img/bg_3.png");
          }
          &:nth-child(4) {
            background-image: url("../../assets/img/bg_4.png");
          }
          background-position: 100% 100%;
          background-repeat: no-repeat;
          background-size: 30%;
          @media screen and (max-width: 768px) {
            height: 140px;
            &:nth-child(n + 3) {
              margin-top: 20px;
            }
          }
          .double_card_bg {
            width: 30px;
            height: 15px;
            background: linear-gradient(90deg, rgba(252, 197, 96, 0), #feb15a);
            @media screen and (max-width: 768px) {
              width: 20px;
              height: 8px;
            }
          }
          p {
            line-height: 20px;
            font-size: 15px;
            margin-top: 30px;
            @media screen and (max-width: 768px) {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}
</style>